module.exports = __webpack_public_path__ + "media/newstyle/images/icon-livrariacultura-f0c8bb3564b67ce64047a85ed126849a.svg";